import { useEffect } from "react";

const SITE_URL = "https://iammanuelsantana.com";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_manuel-pro/artifacts/6esznkq8_bm8i9365-edit.png";

const setMeta = (selectorAttr, value, key, content) => {
  let el = document.head.querySelector(`meta[${selectorAttr}="${value}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(selectorAttr, value);
    document.head.appendChild(el);
  }
  el.setAttribute(key, content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Seo component — injects <title>, meta tags, canonical and JSON-LD per route.
 *
 * Props:
 *  - title:       <title> + og/twitter title
 *  - description: meta description + og/twitter description
 *  - path:        canonical path (e.g. "/about"); used to build absolute URL
 *  - image:       absolute URL for og:image / twitter:image (optional)
 *  - schemas:     array of plain JSON-LD objects to inject as <script type="application/ld+json">
 *  - type:        og:type override (default "website")
 */
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  schemas = [],
  type = "website",
}) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    document.title = title;

    setMeta("name", "description", "content", description);
    setMeta("property", "og:title", "content", title);
    setMeta("property", "og:description", "content", description);
    setMeta("property", "og:url", "content", canonical);
    setMeta("property", "og:type", "content", type);
    setMeta("property", "og:image", "content", image);
    setMeta("property", "og:site_name", "content", "Manuel Santana");
    setMeta("name", "twitter:card", "content", "summary_large_image");
    setMeta("name", "twitter:title", "content", title);
    setMeta("name", "twitter:description", "content", description);
    setMeta("name", "twitter:image", "content", image);
    setMeta("name", "twitter:site", "content", "@iammanuelsantana");
    setMeta("name", "twitter:creator", "content", "@iammanuelsantana");

    setLink("canonical", canonical);

    // Remove any previously-injected route schemas
    document.head.querySelectorAll('script[data-ms-schema="1"]').forEach((n) => n.remove());

    // Inject fresh schemas
    schemas.forEach((s) => {
      const tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.setAttribute("data-ms-schema", "1");
      tag.text = JSON.stringify(s);
      document.head.appendChild(tag);
    });

    return () => {
      document.head.querySelectorAll('script[data-ms-schema="1"]').forEach((n) => n.remove());
    };
  }, [title, description, path, image, type, schemas]);

  return null;
};
